module.exports = __webpack_public_path__ + "static/media/magnifier.209834ab.svg";